module.exports = __webpack_public_path__ + "img/contentJiantou.7c8d5e25.svg";